import React from 'react';
import LazyLoad from 'react-lazy-load';
import '../css/robot.css';

const Robot = (props) => {
  return (
    <div className="robot">
      <h1>{props.robotName}</h1>
      <h2>{props.weightClass}</h2>
      <LazyLoad>
        <img src={props.imageURL} alt={props.robotName} />
      </LazyLoad>
      <table>
        <tbody>
          <tr>
            <th>Speed</th><th>Traction</th><th>Torque</th>
          </tr>
          <tr>
            <td>{props.speed}</td>
            <td>{props.traction}</td>
            <td>{props.torque}</td>
          </tr>
          <tr>
            <th>Weapon</th>
            <td colSpan="2">{props.weapon}</td>
          </tr>
          <tr>
            <th>Armor</th>
            <td colSpan="2">{props.armor}</td>
          </tr>
          {
            props.altConfig && 
            <tr>
              <td colSpan="3">{props.altConfig}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  );
};

export default Robot;


// WEBPACK FOOTER //
// ./src/components/robot.js